import { Checkbox } from 'antd';
import s from './styles';

function CustomCheckbox(props) {
  return (
    <s.Wrapper>
      <Checkbox {...props}>{props.children}</Checkbox>
    </s.Wrapper>
  );
}

export default CustomCheckbox;
